import Vue from 'vue'
import App from './App.vue'
import Axios from 'axios'
import router from './router'
import store from './store'

Vue.config.productionTip = false
Vue.prototype.$http = Axios

Vue.mixin({
  methods: {
    withAuth: function (callback) {
      console.log(store)
      var now = Math.floor(new Date().getTime() / 1000) // current time in seconds
      var exp = store.getters.idTokenData.exp // expiry time of current token in seconds
      var min = 60 // minimum time before expiry in seconds
      console.log('Token valid for another ' + Math.ceil((exp - min - now) / 60) + ' minutes')
      if (exp - min - now < 0) {
        console.log('Token needs to be refreshed')
        this.refreshAuthTokens(callback)
      } else {
        console.log('Token does not need to be refreshed')
        callback()
      }
    },
    refreshAuthTokens: function (callback) {
      var headers = {}
      headers['Content-Type'] = 'application/x-www-form-urlencoded'
      this.$http.post(
        'https://' + window.authEndpoint + '/oauth2/token',
        'grant_type=refresh_token&client_id=' + window.cognitoAppClientId +
        '&refresh_token=' + store.state.auth.refresh_token,
        { headers: headers })
        .then(response => {
          console.log(response)
          if (response.data) {
            store.dispatch('SET_TOKEN', response.data)
            console.log('Token refreshed')
            callback()
          }
        })
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')